/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_AddInputs */

const en_task_catalog_add = /** @type {(inputs: Task_Catalog_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add activity`)
};

const pt_br2_task_catalog_add = /** @type {(inputs: Task_Catalog_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar atividade`)
};

/**
* | output |
* | --- |
* | "Add activity" |
*
* @param {Task_Catalog_AddInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_add = /** @type {((inputs?: Task_Catalog_AddInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_AddInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_add(inputs)
	return pt_br2_task_catalog_add(inputs)
});